import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/components/layout/Layout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'category',
        name: 'Category',
        component: () => import('@/views/category/index.vue'),
        meta: { title: '分类管理' }
      },
      {
        path: 'goods',
        name: 'Goods',
        component: () => import('@/views/goods/index.vue'),
        meta: { title: '商品管理' }
      },
      {
        path: 'goods/add',
        name: 'GoodsAdd',
        component: () => import('@/views/goods/form.vue'),
        meta: { title: '新增商品' }
      },
      {
        path: 'goods/edit/:id',
        name: 'GoodsEdit',
        component: () => import('@/views/goods/form.vue'),
        meta: { title: '编辑商品' }
      },
      {
        path: 'goods/addStock/:id',
        name: 'GoodsAddStock',
        component: () => import('@/views/goods/addStock.vue'),
        meta: { title: '补货' }
      },
      {
        path: 'order',
        name: 'Order',
        component: () => import('@/views/order/index.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'order/:id',
        name: 'OrderDetail',
        component: () => import('@/views/order/detail.vue'),
        meta: { title: '订单详情' }
      },
      {
        path: 'customer-profile',
        name: 'CustomerProfile',
        component: () => import('@/views/customer-profile/index.vue'),
        meta: { title: '客户画像' }
      },
      {
        path: 'customer-profile/detail/:id',
        name: 'CustomerProfileDetail',
        component: () => import('@/views/customer-profile/detail.vue'),
        meta: { title: '客户详情' }
      },
      {
        path: 'account',
        name: 'Account',
        component: () => import('@/views/account/index.vue'),
        meta: { title: '账号管理' }
      },
      {
        path: 'announcement',
        name: 'Announcement',
        component: () => import('@/views/announcement/index.vue'),
        meta: { title: '公告管理' }
      }

    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 从JWT token中解析用户名
function getUsernameFromToken(token) {
  if (!token) return null
  try {
    // JWT token格式：header.payload.signature
    const parts = token.split('.')
    if (parts.length !== 3) return null
    
    // 解析payload部分
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
    return payload.sub || payload.username || null
  } catch (error) {
    console.error('解析token失败:', error)
    return null
  }
}

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  if (to.meta.requiresAuth) {
    if (token) {
      // 检查是否是首页路由，且用户不是"god"
      if (to.path === '/' || to.name === 'Home') {
        const username = getUsernameFromToken(token)
        if (username !== 'god') {
          // 非god用户访问首页，重定向到订单管理页面
          ElMessage.warning('您没有权限访问首页')
          next('/order')
          return
        }
      }
      next()
    } else {
      next('/login')
    }
  } else {
    if (token && to.path === '/login') {
      next('/')
    } else {
      next()
    }
  }
})

export default router 